/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserBanPopoverContainer_settings = {
    readonly auth: {
        readonly integrations: {
            readonly sso: {
                readonly enabled: boolean;
                readonly targetFilter: {
                    readonly admin: boolean;
                };
            };
        };
    };
    readonly " $refType": "UserBanPopoverContainer_settings";
};
export type UserBanPopoverContainer_settings$data = UserBanPopoverContainer_settings;
export type UserBanPopoverContainer_settings$key = {
    readonly " $data"?: UserBanPopoverContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UserBanPopoverContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBanPopoverContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Auth",
            "kind": "LinkedField",
            "name": "auth",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthIntegrations",
                    "kind": "LinkedField",
                    "name": "integrations",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SSOAuthIntegration",
                            "kind": "LinkedField",
                            "name": "sso",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "enabled",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthenticationTargetFilter",
                                    "kind": "LinkedField",
                                    "name": "targetFilter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "admin",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'a5ce42343cdd01c4b764882a66ce147e';
export default node;
